import z from "zod";

import { SLIDER_TOOLTIP_VISIBILITIES } from "./constants";

export const sliderDataSchema = z.object({
  label: z.string().optional(),
  value: z.coerce.number().optional(),
  min: z.coerce.number().optional(),
  max: z.coerce.number().optional(),
  step: z.coerce.number().optional(),
  tooltip: z.enum(SLIDER_TOOLTIP_VISIBILITIES).optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type SliderDataProps = z.infer<typeof sliderDataSchema>;
